import Controller from '@ember/controller';

export default class AthenaeumTransferController extends Controller {
  title = 'Athenaeum Transfer (library software)';
}
